<template>
  <Modal
    :value="modalDeleteServiceTributesIsOpen"
    :onClose="toggleModalDeleteServiceTributes"
    size="tiny"
  >
    <b-row align="center">
      <b-col>
        <AlertCircleOutline class="icon-2x" title="Alerta" />
      </b-col>
    </b-row>
    <b-row align="center" class="mt-2 mb-3">
      <b-col>
        <h2>Tem certeza que deseja excluir?</h2>
      </b-col>
    </b-row>
    <b-row align="center">
      <b-col>
        <Button type="cancel" @click="toggleModalDeleteServiceTributes()">
          <Close class="mb-1" title="Cancelar" /> Cancelar
        </Button>
        <Button @click="handleCancel()" type="success">Confirmar</Button>
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { Button } from '@/components/Form';
import Close from 'vue-material-design-icons/Close';
import AlertCircleOutline from 'vue-material-design-icons/AlertCircleOutline.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ModalDeleteServiceTributes',
  components: {
    Modal,
    Button,
    Close,
    AlertCircleOutline,
  },
  computed: {
    ...mapState('nfseTributes', [
      'summaryServiceTributes',
      'paginationServiceTributes',
      'warnings',
    ]),
    ...mapState('nfseTributesComponents', [
      'modalDeleteServiceTributesIsOpen',
      'modalDeleteServiceTributesIds',
    ]),
  },
  methods: {
    ...mapActions('nfseTributes', [
      'deleteServiceTributes',
      'setSummaryServiceTributes',
    ]),
    ...mapActions('application', ['setLoading']),
    ...mapActions('nfseTributesComponents', [
      'toggleModalDeleteServiceTributes',
    ]),
    async handleCancel() {
      this.setLoading(true);
      await this.deleteServiceTributes(this.modalDeleteServiceTributesIds);
      await this.setSummaryServiceTributes({
        pagination: { ...this.paginationServiceTributes, currentPage: 1 },
      });
      if (this.warnings.length) {
        this.warnings.forEach((i) => {
          this.$alert.warning(i);
        });
      }
      this.setLoading(false);
      this.toggleModalDeleteServiceTributes();
    },
  },
};
</script>

<style scoped>
.icon-2x {
  color: #f8bb86;
  height: 7.5em;
  width: 7.5em;
}

.icon-2x > .material-design-icon__svg {
  height: 7.5em;
  width: 7.5em;
}
</style>
